import type { ApiClient } from '../client';
import { BoxMarksSchema, type BoxMarks } from '../schemas/boxMarks';

const path = (boxId: string) =>
  `/app_service/panel/v1/boxes/${encodeURIComponent(boxId)}/unsync-flags`;

// Read a «buzón»'s unsync-mark level. Box-first, like the box log and the box status.
//
// «Sin marcas» arrives in TWO shapes and this is the only place that knows it: a 204 (the box has no
// unsync-flag row at all) and a 200 carrying `mark: 0` (the row exists and is clean — it is created
// when a box is assigned). The client resolves an empty body to undefined; both normalize to 0 here,
// so nothing above ever branches on which one the server sent.
export async function fetchBoxMarks(client: ApiClient, boxId: string): Promise<BoxMarks> {
  const data = await client.get<unknown>(path(boxId));
  if (data === undefined) return { mark: 0 };
  return BoxMarksSchema.parse(data);
}

// Clear every mark of a «buzón». No body: the write attests a resync that already happened
// physically, and the reset code that produced it never travels. Empty 204 — the caller refetches.
export async function clearBoxMarks(client: ApiClient, boxId: string): Promise<void> {
  await client.delete(path(boxId));
}
